import { WeekDays } from './date-helpers';

export const FIRST_DAY_OF_WEEK = WeekDays.MONDAY;
